module.exports = __webpack_public_path__ + "static/media/page-not-found.d131f212.svg";